/* The name that was just typed, on the "added to cart" confirmation.

   sections/variant-added.liquid is rendered by Shopify as part of the
   cart/add.js request, and all it is told is which VARIANT was added - not
   which line. It finds the line by matching the variant and taking the last
   one, which is right until the same garment is in the cart twice under two
   different names:

     line 1  Hoodie M  "BERG"
     line 2  Hoodie M  "HANSEN"

   Adding another BERG merges into line 1 and leaves it where it is, so the
   last matching line is still HANSEN - and the confirmation reads the
   sibling's name back to the student. Same for a garment added with no name
   at all while a named one sits further down.

   The add response knows exactly which line it wrote, so take it from there.
   `variant:add` carries detail.items, the line items cart/add.js returned, and
   the theme's own listeners swap the server-rendered section in when that
   event reaches them. This listens in the CAPTURE phase so it has the answer
   stashed before that happens, and the element below - which connects as part
   of that swap - reads it synchronously.

   Everything here is a correction, never the source: with no event stashed, or
   a variant that does not match, the server-rendered rows are left exactly as
   they are. */
(function () {
  "use strict";

  var lastAdded = null;

  document.addEventListener(
    "variant:add",
    function (event) {
      var items = event.detail && event.detail.items;
      lastAdded = Array.isArray(items) && items.length ? items[items.length - 1] : null;
    },
    true
  );

  class VariantAddedProperties extends HTMLElement {
    connectedCallback() {
      if (!lastAdded) return;

      // The confirmation can only be for the add that just happened. If it is
      // somehow for a different variant, the server's guess is the better one.
      var wanted = parseInt(this.getAttribute("data-variant-id"), 10);
      if (wanted && Number(lastAdded.variant_id) !== wanted) return;

      var properties = lastAdded.properties || {};
      var rows = document.createDocumentFragment();

      Object.keys(properties).forEach(function (key) {
        var value = properties[key];
        // Shopify's underscore-prefixed properties are internal, and an empty
        // one means the field was deliberately left blank.
        if (!key || key.charAt(0) === "_" || value === null || value === "") return;

        var row = document.createElement("p");
        row.className = "text-sm";
        row.appendChild(document.createTextNode(key + ": "));
        var strong = document.createElement("strong");
        strong.textContent = value;
        row.appendChild(strong);
        rows.appendChild(row);
      });

      this.replaceChildren(rows);
    }
  }

  if (!customElements.get("variant-added-properties")) {
    customElements.define("variant-added-properties", VariantAddedProperties);
  }
})();
